import { render, staticRenderFns } from "./ChatChannelsListElement.vue?vue&type=template&id=c76d5306&scoped=true"
import script from "./ChatChannelsListElement.vue?vue&type=script&lang=js"
export * from "./ChatChannelsListElement.vue?vue&type=script&lang=js"
import style0 from "./ChatChannelsListElement.vue?vue&type=style&index=0&id=c76d5306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76d5306",
  null
  
)

export default component.exports